import { PAYMENT_TYPES, SALE_CATEGORIES } from '../api/use-loyalty-admin';

/**
 * "Vazio = todos" é regra do avaliador no backend, não escolha de tela.
 *
 * Uma campanha sem canal marcado vale em TODOS os canais; sem meio de
 * pagamento marcado, vale em todos. Mostrar isso errado faz alguém marcar os
 * cinco canais "por segurança" e depois não entender por que a campanha parou
 * de valer no canal novo que o Habib's criar.
 */
export function scopeLabel(
  list: readonly number[] | undefined,
  options: readonly { value: number; label: string }[],
): string {
  if (!list || list.length === 0) return 'todos';
  return list.map((v) => options.find((o) => o.value === v)?.label ?? String(v)).join(', ');
}

export function channelLabel(list: readonly number[] | undefined): string {
  return scopeLabel(list, SALE_CATEGORIES);
}

export function paymentLabel(list: readonly number[] | undefined): string {
  return scopeLabel(list, PAYMENT_TYPES);
}

/**
 * Quanto falta para a janela de 24 horas vencer.
 *
 * `vencido` aqui não é cosmético: é o estado que dispara o alarme, porque a
 * falha da liquidação é silenciosa do lado do caixa.
 */
export function settleCountdown(
  status: string,
  settleAfter: string | null,
  now: Date = new Date(),
): string {
  if (status !== 'confirmed' || !settleAfter) return '—';
  const target = new Date(settleAfter).getTime();
  if (Number.isNaN(target)) return '—';
  const diff = target - now.getTime();
  if (diff <= 0) return 'vencido';
  const hours = Math.floor(diff / 3_600_000);
  const minutes = Math.floor((diff % 3_600_000) / 60_000);
  return hours > 0 ? `${hours}h ${minutes}min` : `${minutes}min`;
}
